import { textCase } from "../service/ui/UI";

type LocationDefaultType = {
  country_id: string;
  country_name: string;
  state_id: string;
  state_name: string;
  city_id: string;
  city_name: string;
  area_id: string;
  area_name: string;
};

export const locationDefault: LocationDefaultType = {
  country_id: process.env.REACT_APP_defaults_country_id ?? "197",
  country_name: textCase(
    process.env.REACT_APP_defaults_country_name ?? "South Africa"
  ),
  state_id: process.env.REACT_APP_defaults_state_id ?? "4930",
  state_name: textCase(process.env.REACT_APP_defaults_state_name ?? "Gauteng"),
  city_id: process.env.REACT_APP_defaults_city_id ?? "34417",
  city_name: textCase(
    process.env.REACT_APP_defaults_city_name ?? "Johannesburg"
  ),
  area_id: process.env.REACT_APP_defaults_area_id ?? "3191",
  area_name: textCase(process.env.REACT_APP_defaults_area_name ?? "Lenasia"),
};
